import { render, staticRenderFns } from "./ForecastIndex.vue?vue&type=template&id=70377617"
import script from "./ForecastIndex.vue?vue&type=script&lang=js"
export * from "./ForecastIndex.vue?vue&type=script&lang=js"
import style0 from "./ForecastIndex.vue?vue&type=style&index=0&id=70377617&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports